const ReferralsDashboard = () => {
  return null;
};

export default ReferralsDashboard;
